"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/TextareaInput.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : TextareaInput.js
* Description : Ce fichier contient la définition du composant TextareaInput 
*               Ce composant est un champ texte pour écrire un paragraphe sur plusieurs lignes
* Date de création : 25 septembre 2026
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* TextareaInput : affiche un champ texte pour écrire un paragraphe sur plusieurs lignes
*
* Type : composant 
*
* Parametres : 
*  - label -- texte affiché au dessus du champ pour apporter des précisions
*  - value -- valeur saisie
*  - setValue -- fonction pour mettre à jour la variable value
*/function TextareaInput(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    onkeydown = _ref.onkeydown,
    type = _ref.type,
    placeholder = _ref.placeholder;
  return value !== null ? value.length > 2000 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "textarea-div",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      className: "border-error",
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      },
      onKeyDown: onkeydown,
      type: type,
      placeholder: placeholder
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "caracter-error",
      children: [value.length, " caract\xE8res"]
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "textarea-div",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      className: "border-text",
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      },
      onKeyDown: onkeydown,
      type: type,
      placeholder: placeholder
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "caracter-indication",
      children: [value.length, " caract\xE8res"]
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "textarea-div",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      className: "border-text",
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      },
      onKeyDown: onkeydown,
      type: type,
      placeholder: placeholder
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "caracter-indication",
      children: "0 caract\xE8res"
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
TextareaInput.propTypes = {
  error: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  setValue: _propTypes["default"].func,
  onkeydown: _propTypes["default"].func,
  type: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
var _default = exports["default"] = TextareaInput;